export default __webpack_public_path__ + "static/results-dark-db12698b7e2192521b43d2259f03e9e5.png";